// src/components/ColumnMapper.jsx
import React from "react";
import { MdSwapHoriz } from "react-icons/md";

const ColumnMapper = ({ dbField, csvColumns, selected, onChange, isExport }) => {
  return (
    <div className="grid grid-cols-2 gap-4 items-center bg-gray-50 p-3 rounded-lg border">
      <div>
        <p className="font-medium text-gray-800">{dbField.label}</p>
      </div>

      {isExport ? (
        <input
          type="text"
          value={selected}
          placeholder="Enter column header..."
          onChange={(e) => onChange(dbField.value, e.target.value)}
          className="w-full p-2 border rounded-lg"
        />
      ) : (
        <select
          value={selected}
          onChange={(e) => onChange(dbField.value, e.target.value)}
          className="w-full p-2 border rounded-lg"
        >
          <option value="">-- Select Column --</option>
          {csvColumns.map((col) => (
            <option key={col} value={col}>
              {col}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default ColumnMapper;